export const sortByKey = (key, type) => {
    /* 
     * 根据对象中某一属性值排序或二维数据中某一索引排序
     * @key { String | Number } 对象中属性或数组中索引
     * @type { Boolean } true 为升序 false为降序
     * ex: arr.sort(sortByKey('age', true)) ---- arr = [{age: 12}, {age: 5}]
     */

    return function (value1, value2) {

        if (isNaN(value1[key])) {
            return 1;
        }
        if (isNaN(value2[key])) {
            return -1;
        }
        if (type) {
            return value1[key] - value2[key];
        } else {
            return value2[key] - value1[key];
        }
    }
}